import { createApiSlice } from 'app/createApiSlice'
import { API_SCHEMA_V2, API_SCHEMA_V2_OUTPUT } from 'utils/apiList'

export const mapSchemaApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'mapSchema/api',
  endpoints(builder) {
    return {
      // GET: Fetch schemas by output itemId
      // Response: { totalItems, items: [{ id, createMethodLabel, numInput, numOutput }], totalPages, currentPage }
      fetchMapSchemas: builder.query({
        query({ itemId, s, page, size, sortby, sortdir }) {
          return {
            url: `/${API_SCHEMA_V2_OUTPUT}/${itemId}`,
            params: {
              s: s ?? undefined,
              page: page ?? undefined,
              size: size ?? undefined,
              sortby: sortby ?? undefined,
              sortdir: sortdir ?? undefined,
            },
          }
        },
      }),

      // GET: Fetch single schema detail by schemaId
      // Response: { id, createMethodLabel, output: [...], input: [...], deleted, createdAt, updatedAt }
      getSchemaDetail: builder.query({
        query(schemaId) {
          return {
            url: `/${API_SCHEMA_V2}/${schemaId}`,
            method: 'GET',
          }
        },
      }),

      // POST: Create or Update schema
      // Create: omit id, Update: include id
      // Request body: { id?, createMethodLabel, input: [{ itemId, reqAmount?, unit? }], output: [{ itemId, amount?, unit?, outputPerHour? }] }
      createOrUpdateSchema: builder.mutation({
        query(payload) {
          return {
            url: `/${API_SCHEMA_V2}/`,
            method: 'POST',
            body: payload,
          }
        },
      }),

      // DELETE: Soft delete schema by schemaId
      deleteMapSchema: builder.mutation({
        query(schemaId) {
          return {
            url: `/${API_SCHEMA_V2}`,
            method: 'DELETE',
            params: {
              id: schemaId,
            },
          }
        },
      }),

      // POST: Rename schema label
      renameSchema: builder.mutation({
        query(payload) {
          return {
            url: `/${API_SCHEMA_V2}/rename`,
            method: 'POST',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchMapSchemasQuery,
  useLazyFetchMapSchemasQuery,
  useGetSchemaDetailQuery,
  useLazyGetSchemaDetailQuery,
  useCreateOrUpdateSchemaMutation,
  useDeleteMapSchemaMutation,
  useRenameSchemaMutation,
} = mapSchemaApiSlice
